<div class="create-password">
  @if (unknownError) {
    <se-fe-alert seFeDataType="error">
      There was an error creating your account. Please try again later.
    </se-fe-alert>
  }

  <header>
    <h3>Create your password</h3>
  </header>

  <div role="content">
    @if (!ready) {
      <div>
        <se-fe-spinner
          [seFeDataSize]="900"
          [seFeDataInverted]="false"
          [seFeDataCenter]="true">
        </se-fe-spinner>
      </div>
    }
    @if (ready) {
      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        novalidate>
        <input
          name="username"
          autocomplete="username"
          type="hidden"
          type="email"
          style="display: none"
          [value]="email" />
        <se-fe-form-field
        [seFeDataConfig]="{
          label: 'Password',
          errorMessages: {
            required: 'This is required',
            passwordMin: 'Must be at least 8 characters',
            passwordUpper: 'Must include one uppercase character',
            passwordLower: 'Must include one lowercase character',
            passwordNonAlpha: 'Must include one number or symbol'
          }
        }">
        <se-fe-form-field-text
          formControlName="password"
          seFeDataPlaceholder="Enter your password"
          [seFeDataType]="fieldType"
          seFeDataAutoComplete="new-password">
          <se-fe-icon-button
            (click)="toggleFieldType()"
            seFeFormFieldTextAfter>
            <se-fe-icon
              [seFeDataName]="iconName"
              seFeDataSize="700"
              [seFeDataAriaLabel]="'Show Password'">
            </se-fe-icon>
          </se-fe-icon-button>
        </se-fe-form-field-text>
        <se-fe-form-control-help>
          Password must be at least 8 characters and include
          one uppercase letter, one lowercase letter,
          and one number or symbol.
        </se-fe-form-control-help>
      </se-fe-form-field>
      <div class="form-field single-check">
        <se-fe-checkbox
          formControlName="specialOffers"
          [seFeDataOptions]="
            [{
              label: 'Send me news, updates, offers, and more from SportsEngine and its affiliated brands.',
              value: true,
            }]
          ">
        </se-fe-checkbox>
      </div>
      <div class="form-field single-check" style="display: flex;">
        <div>
          <se-fe-checkbox
            formControlName="thirdPartyMailing"
            [seFeDataOptions]="
              [{
                label: 'Sign me up to receive email offers and promotional messages from SportsEngine about products and services offered by our partners and affiliates.',
                value: true,
              }]
            ">
          </se-fe-checkbox>
        </div>
        <div style="align-self: center; margin-left: 10px;">
          <se-fe-icon
            [seFePopoverTrigger]="thirdPartyMailingPopover"
            seFeDataName="info_circle"
            seFeDataSize="500"
            seFeDataColor="gray-600"
            seFeDataMargin="false"
            style="cursor: pointer;">
          </se-fe-icon>
          <se-fe-popover #thirdPartyMailingPopover>
            <div>Other NBC Sports Next brands (GolfNow, GolfPass & TeeOff) and partners that we think would be of interest to you.</div>
          </se-fe-popover>
        </div>
      </div>
      <div class="create-password-submit">
        <se-fe-button
          seFeDataEmphasis="high"
          seFeDataType="submit"
          [seFeDataIsLoading]="submitting"
          [seFeDataFullWidth]="true">
          Create Account
        </se-fe-button>
        <!-- New terms for non-US/Canada TeamUnify users -->
        @if (!isUSOrCanada() && isTeamUnifyBrand) {
          <se-fe-form-control-help>
            By creating a SportsEngine account, you accept that your use of our platform is subject to the
            Terms of Use and take note of the supplementary data protection information relating to the SportsEngine account:
            <a seFeLink href="https://www.sportsengine.com/privacy-center/terms-of-use">Terms of Use and Supplementary Privacy Notice for the SE account.</a>
            General information about SE's processing of your personal data can be found here:
            <a seFeLink href="https://www.sportsengine.com/privacy-center/privacy-policy">Privacy Policy</a>.
          </se-fe-form-control-help>
        }
        <!-- Default terms for everyone else -->
        @if (isUSOrCanada() || !isTeamUnifyBrand) {
          <se-fe-form-control-help>
            By creating an account you acknowledge and agree that your use of our
            platform is subject to the SportsEngine
            <a seFeLink href="https://www.sportsengine.com/privacy-center/terms-of-use">Terms of Use</a>
            and
            <a seFeLink href="https://www.sportsengine.com/privacy-center/privacy-policy">Privacy Policy</a>.
            Use of websites is subject to that site's Privacy Policy and Terms of Use.
          </se-fe-form-control-help>
        }
      </div>
      <se-po-household-setup-already-have-account></se-po-household-setup-already-have-account>
    </form>
  }
</div>
</div>
@if (recaptchaKey) {
  <re-captcha ng-container
    #captchaRef
    [siteKey]="recaptchaKey"
    size="invisible"
    (resolved)="$event && recaptchaResolved($event)"
    (error)="recaptchaErrored()"
  ></re-captcha>
}
